// These are customized versions of the auto-generated mutations.ts

import gql from "graphql-tag";

// Account mutations

export const createAccount = /* GraphQL */ gql`
  mutation CreateAccount(
    $input: CreateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    createAccount(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      ownerId  
      name
      address
      city
      state
      postalCode
      accountType
      accountStatus
      accountSize  
      customerId
    }
  }
`;

export const updateAccount = /* GraphQL */ gql`
  mutation UpdateAccount(
    $input: UpdateAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    updateAccount(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      ownerId
      name
      address
      city
      state
      postalCode
      accountType
      accountStatus
      accountSize  
      customerId  
    }
  }
`;
export const deleteAccount = /* GraphQL */ gql`
  mutation DeleteAccount(
    $input: DeleteAccountInput!
    $condition: ModelAccountConditionInput
  ) {
    deleteAccount(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      name
      address
      city
      state
      postalCode
      accountType
      accountStatus
      accountSize  
      customerId  
    }
  }
`;

// Agreement

export const createAgreement = /* GraphQL */ gql`
    mutation CreateAgreement(
        $input: CreateAgreementInput!
        $condition: ModelAgreementConditionInput
    ) {
        createAgreement(input: $input, condition: $condition) {
            id
            createdAt
            updatedAt
            userId
            accountId
            agreementTypes
            agreementKey
        }
    }
`;

// Class mutations

export const createClass = /* GraphQL */ gql`
  mutation CreateClass(
    $input: CreateClassInput!
    $condition: ModelClassConditionInput
  ) {
    createClass(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      courseId
      accountId
      ownerId
      userId  
      termBegin
      termEnd
      seatsPurchased
      seatsFilled
      couponCode
      assignmentSchedule
    }
  }
`;
export const updateClass = /* GraphQL */ gql`
  mutation UpdateClass(
    $input: UpdateClassInput!
    $condition: ModelClassConditionInput
  ) {
    updateClass(input: $input, condition: $condition) {
        id
        createdAt
        updatedAt
        courseId
        accountId
        ownerId
        userId
        termBegin
        termEnd
        seatsPurchased
        seatsFilled
        couponCode
        assignmentSchedule
    }
  }
`;
export const deleteClass = /* GraphQL */ gql`
  mutation DeleteClass(
    $input: DeleteClassInput!
    $condition: ModelClassConditionInput
  ) {
    deleteClass(input: $input, condition: $condition) {
        id
        createdAt
        updatedAt
        courseId
        accountId
        ownerId
        userId
        termBegin
        termEnd
        seatsPurchased
        seatsFilled
        couponCode
        assignmentSchedule
    }
  }
`;

// Course mutations

export const createCourse = /* GraphQL */ gql`
  mutation CreateCourse(
    $input: CreateCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    createCourse(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      title
      description
      coverUrl
      details
      publishDate
      sunsetDate
      lessonCount
      creditHours
      isFree
      lessons
      handoutUrl
    }
  }
`;
export const updateCourse = /* GraphQL */ gql`
  mutation UpdateCourse(
    $input: UpdateCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    updateCourse(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      title
      description
      coverUrl
      details
      publishDate
      sunsetDate
      lessonCount
      creditHours
      isFree
      lessons
      handoutUrl
    }
  }
`;
export const deleteCourse = /* GraphQL */ gql`
  mutation DeleteCourse(
    $input: DeleteCourseInput!
    $condition: ModelCourseConditionInput
  ) {
    deleteCourse(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      title
      description
      coverUrl
      details
      publishDate
      sunsetDate
      lessonCount
      creditHours
      isFree
      lessons
      handoutUrl
    }
  }
`;

// Registration mutations

export const createRegistration = /* GraphQL */ gql`
  mutation CreateRegistration(
    $input: CreateRegistrationInput!
    $condition: ModelRegistrationConditionInput
  ) {
    createRegistration(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      accountId
      classId
      userId
      classStatus
      classProgress
      lessonNumber
      lessonId 
      lessonStatus  
      videoProgress
      answers
      score
      startedAt
      endsAt
      completedAt
      lessonsAssigned
      nextAssignmentAt
    }
  }
`;
export const updateRegistration = /* GraphQL */ gql`
  mutation UpdateRegistration(
    $input: UpdateRegistrationInput!
    $condition: ModelRegistrationConditionInput
  ) {
    updateRegistration(input: $input, condition: $condition) {
        id
        createdAt
        updatedAt
        accountId
        classId
        userId
        classStatus
        classProgress
        lessonNumber
        lessonId
        lessonStatus
        videoProgress
        answers
        score
        startedAt
        endsAt
        completedAt
        lessonsAssigned
        nextAssignmentAt
    }
  }
`;
export const deleteRegistration = /* GraphQL */ gql`
  mutation DeleteRegistration(
    $input: DeleteRegistrationInput!
    $condition: ModelRegistrationConditionInput
  ) {
    deleteRegistration(input: $input, condition: $condition) {
        id
        createdAt
        updatedAt
        accountId
        classId
        userId
        classStatus
        classProgress
        lessonNumber
        lessonId
        lessonStatus
        videoProgress
        answers
        score
        startedAt
        endsAt
        completedAt
        lessonsAssigned
        nextAssignmentAt
    }
  }
`;

// User mutations

export const createUser = /* GraphQL */ gql`
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      invitedAt
      accountId
      firstName
      lastName
      email
      phone
      jobTitle
      userStatus
      active  
      role
      customerId
    }
  }
`;
export const updateUser = /* GraphQL */ gql`
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      invitedAt  
      accountId
      firstName
      lastName
      email
      phone
      jobTitle
      userStatus
      active
      role
      customerId  
    }
  }
`;
export const deleteUser = /* GraphQL */ gql`
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      invitedAt  
      accountId
      firstName
      lastName
      email
      phone
      jobTitle
      userStatus
      active  
      role
      customerId  
    }
  }
`;

// ActivityLog

export const createActivity = /* GraphQL */ gql`
  mutation CreateActivity(
    $input: CreateActivityInput!
    $condition: ModelActivityConditionInput
  ) {
    createActivity(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      accountId
      userId
      activityDate
      activityType
      objectId
      values
    }
  }
`;
